/*
=========================================================
* Call It In LLC - [Component Name]
=========================================================

* Company: Call It In LLC
* Website: https://www.justcallitin.com
* Author: Shaun Matthews
* Copyright: © 2025 Call It In LLC. All rights reserved.

=========================================================
* This file is part of the Call It In dashboard system.
* Any reproduction or distribution without written consent is strictly prohibited.
=========================================================
*/


import pxToRem from "assets/theme/functions/pxToRem";

const svgIcon = {
  defaultProps: {
    fontSize: "inherit",
  },

  styleOverrides: {
    fontSizeInherit: {
      fontSize: "inherit !important",
    },

    fontSizeSmall: {
      fontSize: `${pxToRem(20)} !important`,
    },

    fontSizeLarge: {
      fontSize: `${pxToRem(36)} !important`,
    },
  },
};

export default svgIcon;
